import React, { useState, useRef, useEffect } from 'react';
import { Button, InputNumber, Space } from 'antd';
import { formatAmount } from '~/utils/function';
import { PencilSimpleLine } from '@phosphor-icons/react';

const CurrencyInput = ({ value, onChange, unit = '¥', ...inputProps }: any) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);

  // 清空输入
  const handleClear = (e: { stopPropagation: () => void }) => {
    e.stopPropagation(); // 阻止事件冒泡
    onChange(0);
  };

  // 点击外部区域结束编辑
  useEffect(() => {
    const handleClickOutside = (e: any) => {
      // @ts-ignore
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        setEditing(false);
      }
    };

    if (editing) {
      onChange(value); // 确保在编辑时更新值
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [editing]);

  return (
    <div ref={inputRef} className="recharge-amount-value" style={{ display: 'inline-block' }}>
      {editing ? (
        <InputNumber
          autoFocus
          prefix={unit}
          placeholder="请输入金额"
          value={value}
          onChange={onChange}
          onPressEnter={() => setEditing(false)}
          style={{ minWidth: 100, border: 0 }}
          precision={0}
          min={5}
          max={100000}
          step={10}
          // addonAfter={<DeleteOutlined onClick={handleClear} />}
          {...inputProps}
        />
      ) : (
        <Space onClick={() => setEditing(true)} className="gap-0">
          {formatAmount(value, { currency: unit })}
          <Button
            type="link"
            icon={<PencilSimpleLine size={20} weight="bold" />}
            onClick={(e) => {
              e.stopPropagation(); // 阻止事件冒泡
              setEditing(true);
            }}
          />
        </Space>
      )}
    </div>
  );
};

export default CurrencyInput;
